import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://maisonria.com";

const ROUTES = {
  "/": {
    title: "Nanoblading Paris — Maison Ria | Studio de dermopigmentation",
    desc: "Studio privé à Paris 17ᵉ : nanoblading, microblading, lip blush, tricopigmentation, browlift et soins experts de la peau. Sur rendez-vous uniquement.",
  },
  "/studio": {
    title: "Prestations & tarifs dermopigmentation | Maison Ria Paris 17",
    desc: "Nanoblading, lip blush, taches de rousseur, tricopigmentation, browlift, nanoneedling : la carte complète du studio Maison Ria à Paris 17ᵉ.",
  },
  "/academie": {
    title: "Formation nanoblading Paris — L'Académie Maison Ria",
    desc: "Formations dermopigmentation en one-to-one à Paris et en vidéo : nanoblading, microblading, tricopigmentation, browlift, mapping. Certificat inclus.",
  },
  "/mentions-legales": {
    title: "Mentions légales — Maison Ria, dermopigmentation Paris 17",
    desc: "Mentions légales du site Maison Ria, studio de dermopigmentation au 30 rue de Saussure, 75017 Paris.",
  },
  "/cgv": {
    title: "Conditions générales de vente — Maison Ria",
    desc: "Conditions générales de vente applicables aux prestations et formations Maison Ria, studio de dermopigmentation à Paris 17ᵉ.",
  },
  "/confidentialite": {
    title: "Politique de confidentialité — Maison Ria",
    desc: "Politique de confidentialité de Maison Ria : données collectées, durées de conservation et vos droits (RGPD).",
  },
};

export default function RouteSeo() {
  const { pathname } = useLocation();
  const seo = ROUTES[pathname];
  if (!seo) return null;

  const url = `${SITE}${pathname === "/" ? "/" : pathname}`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.desc} />
    </Helmet>
  );
}
